import { createAction } from 'redux-actions';

export const changeLanguageActions = createAction('CHANGE_LANGUAGE_ACTIONS');

export const changeLanguageOtherActions = createAction('CHANGE_LANGUAGE_OTHER_ACTIONS');
export const changeLanguageOtherInit = createAction('CHANGE_LANGUAGE_OTHER_INIT');

export const updateLanguageInit = createAction('UPDATE_LANGUAGE_INIT');
export const updateLanguageRequest = createAction('UPDATE_LANGUAGE_REQUEST');
export const updateLanguageReceived = createAction('UPDATE_LANGUAGE_RECEIVED');
export const updateLanguageFailure = createAction('UPDATE_LANGUAGE_FAILURE');
